import { FC } from "react";
import { ElementoAtributos } from ".";
import "./style.css";
import { NewReleases } from "@mui/icons-material";
import theme from "src/theme/light";

export interface  INotificacaoItem {
  notificacao: ElementoAtributos;
  visualizado?: boolean;
  onClick: (notificacao: ElementoAtributos) => void
};

 const NotificacaoItem: FC<INotificacaoItem> =  ({ notificacao, onClick, visualizado = false }) => {
  
  const handleClick = () => {
    onClick(notificacao);
  };
  
  return (
      <div onClick={handleClick} className="popover-element">
        <div className={`notificacao-titulo${visualizado ? "" : " new"}`}>{notificacao.titulo}</div>
        <div className={`notificacao-descricao${visualizado ? "" : " new"}`}>{notificacao.subTitulo}</div>
      </div>
  );
}

export { NotificacaoItem }
